import type { ShareReadingRequest } from '@tarot/shared';

/**
 * 로그인 전에 본 결과를 "저장 대기"로 잠시 맡아두는 곳.
 *
 * 비회원이 방에서 결과를 본 뒤 로그인하면 OAuth 리다이렉트로 화면을 떠나기 때문에,
 * 그냥 두면 그 결과가 사라진다. 로그인하러 가기 직전에 여기 담아두고,
 * 돌아와서 로그인 상태가 확인되면 그때 발행한다(usePublishReading).
 *
 * sessionStorage를 쓰는 이유: 탭을 닫으면 사라져야 하고, 개인정보가 아닌
 * 방금 본 결과일 뿐이라 오래 남길 이유가 없다.
 */
const KEY = 'tw:pendingReading';

export function stashReading(data: ShareReadingRequest): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify(data));
  } catch {
    /* 저장소 불가(시크릿 모드 등) — 저장 유도만 실패, 서비스는 정상 */
  }
}

/** 꺼내면서 지운다 (중복 발행 방지) */
export function takeStashedReading(): ShareReadingRequest | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    sessionStorage.removeItem(KEY);
    return JSON.parse(raw) as ShareReadingRequest;
  } catch {
    return null;
  }
}

export function hasStashedReading(): boolean {
  try {
    return !!sessionStorage.getItem(KEY);
  } catch {
    return false;
  }
}
